import request from '@/utils/request';

// 用户密码登录
export function login(data) {
  return request({
    url: '/auth/front/login',
    method: 'post',
    data
  });
}

// 手机号验证码登录
export function codeLogin(data) {
  return request({
    url: '/auth/front/emailLogin',
    method: 'post',
    data
  });
}

// email验证码登录
export function emailLogin(data) {
  return request({
    url: '/auth/front/emailLogin',
    method: 'post',
    data
  });
}

// 重设密码并登录
export function updatePswLogin(data) {
  return request({
    url: '/auth/front/changePwdByEmail',
    method: 'post',
    data
  });
}

// 重设密码并登录（email）
export function updateEmailPswLogin(data) {
  return request({
    url: '/auth/front/changePwdByEmail',
    method: 'post',
    data
  });
}

// 注册
export function register(data) {
  return request({
    url: '/auth/front/register',
    method: 'post',
    data
  });
}

// 发送验证码
export function sendCode(data) {
  return request({
    url: '/auth/front/sendEmailCode',
    method: 'post',
    data
  });
}

// 发送email验证码
export function sendEmailCode(data) {
  return request({
    url: '/auth/front/sendEmailCode',
    method: 'post',
    data
  });
}

// 登出
export function logout(data) {
  return request({
    url: '/auth/front/logout',
    method: 'delete',
    data
  });
}

// 用户详情
export function getUserInfo(params) {
  return request({
    url: '/system/front/account/user',
    method: 'get',
    params
  });
}

// 带用户认证信息的用户详情
export function getUserDetails(params) {
  return request({
    url: '/system/front/account/listInfo',
    method: 'get',
    params
  });
}

// 注册后认证绑定教职工
export function bindEduStaff(staffCode) {
  return request({
    url: `/system/front/authentication/bind/${staffCode}`,
    method: 'post'
  });
}

// 注册后认证绑定默认海亮学生
export function bindStaffDefaultStudent(data) {
  return request({
    url: '/system/front/hlStudent/confirmBind',
    method: 'post',
    data
  });
}

// 多网校获取code
export function getXCode(params) {
  return request({
    url: `/system/front/campus/code/${params}`,
    method: 'get'
  });
}

// 完善 注册完默认生成的学生信息
export function updateDefaultStudent(data) {
  return request({
    url: '/system/front/student/update/def/student',
    method: 'post',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/login/index.js